import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from '../../application/SnackbarProvider/snackbarSlice';
import loadingReducer from '../../application/Loading/loadingSlice';
import errorHandlerSlice from '../../components/ErrorHandler/errorHandlerSlice';
import requestSlice from '../../application/Request/requestSlice';
import requestSearchSlice from '../../application/SearchRequest/requestSearchSlice';
import userSlice from '../../application/User/userSlice';
import localitiesSlice from '../../components/Localities/localitiesSlice';
import settingsSlice from '../../application/Settings/settingsSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    loading: loadingReducer,
    errorHandler: errorHandlerSlice,
    request: requestSlice,
    requestSearch: requestSearchSlice,
    user: userSlice,
    localities: localitiesSlice,
    settings: settingsSlice
  }
});

export type RootStore = ReturnType<typeof store.getState>;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootStore> = useSelector;

export default store;
